export const BTN_CLICK_EVENT = {
  on: 'btnClick',
  label: '按钮点击',
  eventtype: 'VUE',
};
